import { Box, Chip, Stack, Typography } from '@mui/material';

function SectionHeading({ eyebrow, title, subtitle, light = false, align = 'center' }) {
  return (
    <Stack
      spacing={1.75}
      sx={{
        mb: { xs: 4, md: 6 },
        textAlign: align,
        alignItems: align === 'center' ? 'center' : 'flex-start',
      }}
    >
      {eyebrow ? (
        <Chip
          label={eyebrow}
          sx={{
            bgcolor: 'rgba(201,168,76,0.14)',
            color: '#c9a84c',
            border: '1px solid rgba(201,168,76,0.22)',
            fontWeight: 800,
          }}
        />
      ) : null}
      <Typography
        variant="h2"
        sx={{
          color: light ? '#ffffff' : 'text.primary',
          fontSize: { xs: '2.2rem', md: '3rem' },
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography sx={{ color: light ? 'rgba(255,255,255,0.76)' : 'text.secondary', maxWidth: 760 }}>
          {subtitle}
        </Typography>
      ) : null}
      <Box sx={{ width: 60, height: 2, bgcolor: '#c9a84c', borderRadius: 999 }} />
    </Stack>
  );
}

export default SectionHeading;
